import React, { useState, useEffect, Fragment } from 'react';
import { TextField, Box, Button, CircularProgress, Typography, Card, CardActions, CardContent, CardHeader, DateTime } from '@mui/material';

import { useNotify } from 'react-admin'
import client from '../common/client';
import Help from '../component/Help'

const ProjectBFrontConfigDistribution = props => {
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);

    const distributeNow = (e) => {
        setLoading(true)
        client.request_post(`/api/distribution/front/config`, {project_id:props.project.id}).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Distrubute Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    useEffect(() => {
    }, [props.project])

    return (
        <Card >
            <CardHeader
                title="Config Distribution"
                action={
                    <Help />
                }
            />
            <CardContent>
                <Box>
                    AWS(Access Id, Secret Key, Region),
                    Host Config, To Github Repository
                </Box>
            </CardContent>
            <CardActions>
                <Box m={1}>
                    <Button variant="contained" color="primary" startIcon={loading && <CircularProgress size={24} />} onClick={distributeNow} disabled={loading}>
                        Config To Git</Button>
                </Box>
            </CardActions>
        </Card>
    );
};

export default ProjectBFrontConfigDistribution;
